'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Label = require('../Label/Label');

var _Label2 = _interopRequireDefault(_Label);

var _Container = require('./components/Container.Switch');

var _Container2 = _interopRequireDefault(_Container);

var _Toggle = require('./components/Toggle.Switch');

var _Toggle2 = _interopRequireDefault(_Toggle);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Switch = function Switch(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      children = _ref.children,
      size = _ref.size,
      disabled = _ref.disabled,
      green = _ref.green;
  return _react2.default.createElement(_Label2.default, {
    label: children
  }, _react2.default.createElement(_Container2.default, {
    on: value ? 1 : 0,
    onClick: function onClick(e) {
      if (disabled) return;
      onChange(!value);
    },
    size: size,
    disabled: disabled,
    green: green
  }, _react2.default.createElement(_Toggle2.default, {
    on: value ? 1 : 0,
    size: size
  })));
}; // Components


Switch.propTypes = {
  value: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  children: _propTypes2.default.node,
  size: _propTypes2.default.oneOf(['small', 'normal', 'large']),
  disabled: _propTypes2.default.bool,
  green: _propTypes2.default.bool
};
Switch.defaultProps = {
  label: null,
  size: 'normal',
  disabled: false,
  green: false
};
exports.default = Switch;